import {UserRoleType} from "../../../../../common/access/UserRoleType";
import {UserDto} from "../../../../../common/apis/user/UserDto";

export class UserRoleProvider {

    static getAssignableRolesForUser(loggedUser: UserDto, userRole: UserRoleType, userLogin: string): UserRoleType[] {
        if (loggedUser.login === userLogin) {
            return [loggedUser.role];
        }
        if (loggedUser.role === UserRoleType.ROLE_ADMIN) {
            return [UserRoleType.ROLE_ADMIN, UserRoleType.ROLE_SPRAVCE, UserRoleType.ROLE_OPERATOR];
        }
        if (loggedUser.role === UserRoleType.ROLE_SPRAVCE) {
            if (userRole === UserRoleType.ROLE_ADMIN) {
                return [UserRoleType.ROLE_ADMIN]
            } else {
                return [UserRoleType.ROLE_SPRAVCE, UserRoleType.ROLE_OPERATOR];
            }
        } else return [userRole];
    }
}
